import { useLocation } from "react-router-dom";
import { useCurrentTramite } from "./useCurrentTramite"

export const useCurrentCategoria = () => {
  const { state } = useLocation();
  const tramite = useCurrentTramite();
  return tramite?.otros?.categoria ?? state?.categoria;
}